export const products = [
  // LIVING ROOM (12 products)
  {
    id: 1,
    name: "Linen 3-Seater Sofa",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 1899.00,
    old_price: 2299.00,
    date: "2025-11-01",
    available: true
  },
  {
    id: 2,
    name: "Oak Coffee Table",
    image: "https://images.unsplash.com/photo-1533090481720-856c6e3c1fdc?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 549.00,
    old_price: 699.00,
    date: "2025-11-02",
    available: true
  },
  {
    id: 3,
    name: "Velvet Accent Armchair",
    image: "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 849.00,
    old_price: 1099.00,
    date: "2025-11-03",
    available: true
  },
  {
    id: 4,
    name: "Entertainment TV Unit",
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 699.00,
    old_price: 899.00,
    date: "2025-11-04",
    available: true
  },
  {
    id: 5,
    name: "Modern Floor Lamp",
    image: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 249.00,
    old_price: 329.00,
    date: "2025-11-05",
    available: true
  },
  {
    id: 6,
    name: "Wool Area Rug",
    image: "https://images.unsplash.com/photo-1575414003591-ece8d0416c7a?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 399.00,
    old_price: 549.00,
    date: "2025-11-06",
    available: true
  },
  {
    id: 7,
    name: "Oak Bookshelf",
    image: "https://images.unsplash.com/photo-1594620302200-9a762244a156?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 599.00,
    old_price: 749.00,
    date: "2025-11-07",
    available: true
  },
  {
    id: 8,
    name: "Round Side Table",
    image: "https://images.unsplash.com/photo-1611486212557-88be5ff6f941?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 179.00,
    old_price: 239.00,
    date: "2025-11-08",
    available: true
  },
  {
    id: 9,
    name: "Linen Cushion Set",
    image: "https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 89.00,
    old_price: 129.00,
    date: "2025-11-09",
    available: true
  },
  {
    id: 10,
    name: "Leather Ottoman",
    image: "https://images.unsplash.com/photo-1540574163026-643ea20ade25?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 329.00,
    old_price: 429.00,
    date: "2025-11-10",
    available: true
  },
  {
    id: 11,
    name: "Media Console",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 799.00,
    old_price: 999.00,
    date: "2025-11-11",
    available: true
  },
  {
    id: 12,
    name: "Ceramic Table Lamp",
    image: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?auto=format&fit=crop&w=800&q=80",
    category: "living",
    new_price: 149.00,
    old_price: 199.00,
    date: "2025-11-12",
    available: true
  },

  // BEDROOM (12 products)
  {
    id: 13,
    name: "King Upholstered Bed Frame",
    image: "https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 1499.00,
    old_price: 1899.00,
    date: "2025-11-13",
    available: true
  },
  {
    id: 14,
    name: "Memory Foam Mattress",
    image: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 899.00,
    old_price: 1199.00,
    date: "2025-11-14",
    available: true
  },
  {
    id: 15,
    name: "Bedside Table",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 249.00,
    old_price: 329.00,
    date: "2025-11-15",
    available: true
  },
  {
    id: 16,
    name: "Round Wall Mirror",
    image: "https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 199.00,
    old_price: 269.00,
    date: "2025-11-16",
    available: true
  },
  {
    id: 17,
    name: "Linen Bedding Set",
    image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 329.00,
    old_price: 449.00,
    date: "2025-11-17",
    available: true
  },
  {
    id: 18,
    name: "Wooden Dresser",
    image: "https://images.unsplash.com/photo-1551298370-9d3d53bc4dc3?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 849.00,
    old_price: 1099.00,
    date: "2025-11-18",
    available: true
  },
  {
    id: 19,
    name: "Wardrobe Cabinet",
    image: "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 1299.00,
    old_price: 1699.00,
    date: "2025-11-19",
    available: true
  },
  {
    id: 20,
    name: "Bedside Lamp",
    image: "https://images.unsplash.com/photo-1517991104123-1d56a6e81ed9?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 129.00,
    old_price: 169.00,
    date: "2025-11-20",
    available: true
  },
  {
    id: 21,
    name: "Knitted Throw Blanket",
    image: "https://images.unsplash.com/photo-1580301762395-21ce84d00bc6?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 119.00,
    old_price: 159.00,
    date: "2025-11-21",
    available: true
  },
  {
    id: 22,
    name: "Decorative Pillows",
    image: "https://images.unsplash.com/photo-1629949009765-40fc74c9ec21?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 79.00,
    old_price: 109.00,
    date: "2025-11-22",
    available: true
  },
  {
    id: 23,
    name: "Bedroom Bench",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 379.00,
    old_price: 499.00,
    date: "2025-11-23",
    available: true
  },
  {
    id: 24,
    name: "Blackout Curtains",
    image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=800&q=80",
    category: "bedroom",
    new_price: 159.00,
    old_price: 219.00,
    date: "2025-11-24",
    available: true
  },

  // DINING (12 products)
  {
    id: 25,
    name: "Solid Oak Dining Table",
    image: "https://images.unsplash.com/photo-1617806118233-18e1de247200?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 1599.00,
    old_price: 1999.00,
    date: "2025-11-25",
    available: true
  },
  {
    id: 26,
    name: "Set of 4 Dining Chairs",
    image: "https://images.unsplash.com/photo-1503602642458-232111445657?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 699.00,
    old_price: 899.00,
    date: "2025-11-26",
    available: true
  },
  {
    id: 27,
    name: "Ceramic Dinnerware Set",
    image: "https://images.unsplash.com/photo-1603199506016-5f36e6d72d31?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 169.00,
    old_price: 229.00,
    date: "2025-11-27",
    available: true
  },
  {
    id: 28,
    name: "Glass Pendant Light",
    image: "https://images.unsplash.com/photo-1524484485831-a92ffc0de03f?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 349.00,
    old_price: 449.00,
    date: "2025-11-28",
    available: true
  },
  {
    id: 29,
    name: "Wooden Sideboard",
    image: "https://images.unsplash.com/photo-1604578762246-41134e37f9cc?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 1199.00,
    old_price: 1499.00,
    date: "2025-11-29",
    available: true
  },
  {
    id: 30,
    name: "Linen Table Runner",
    image: "https://images.unsplash.com/photo-1449247709967-d4461a6a6103?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 59.00,
    old_price: 79.00,
    date: "2025-11-30",
    available: true
  },
  {
    id: 31,
    name: "Set of 2 Bar Stools",
    image: "https://images.unsplash.com/photo-1503602642458-232111445657?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 349.00,
    old_price: 459.00,
    date: "2025-12-01",
    available: true
  },
  {
    id: 32,
    name: "Wine Glasses Set",
    image: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 79.00,
    old_price: 109.00,
    date: "2025-12-02",
    available: true
  },
  {
    id: 33,
    name: "Cutlery Set",
    image: "https://images.unsplash.com/photo-1584646886686-2845319c8257?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 129.00,
    old_price: 169.00,
    date: "2025-12-03",
    available: true
  },
  {
    id: 34,
    name: "Serving Platter",
    image: "https://images.unsplash.com/photo-1603199506016-5f36e6d72d31?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 89.00,
    old_price: 119.00,
    date: "2025-12-04",
    available: true
  },
  {
    id: 35,
    name: "Dining Bench",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 499.00,
    old_price: 649.00,
    date: "2025-12-05",
    available: true
  },
  {
    id: 36,
    name: "Candle Holder Set",
    image: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&w=800&q=80",
    category: "dining",
    new_price: 49.00,
    old_price: 69.00,
    date: "2025-12-06",
    available: true
  },

  // DECOR (12 products)
  {
    id: 37,
    name: "Ceramic Vase Set",
    image: "https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 99.00,
    old_price: 139.00,
    date: "2025-12-07",
    available: true
  },
  {
    id: 38,
    name: "Monstera Plant in Pot",
    image: "https://images.unsplash.com/photo-1614594975525-e45190c55d0b?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 89.00,
    old_price: 119.00,
    date: "2025-12-08",
    available: true
  },
  {
    id: 39,
    name: "Abstract Canvas Print",
    image: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 229.00,
    old_price: 299.00,
    date: "2025-12-09",
    available: true
  },
  {
    id: 40,
    name: "Scented Candle Set",
    image: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 59.00,
    old_price: 79.00,
    date: "2025-12-10",
    available: true
  },
  {
    id: 41,
    name: "Woven Storage Basket",
    image: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 89.00,
    old_price: 119.00,
    date: "2025-12-11",
    available: true
  },
  {
    id: 42,
    name: "Decorative Throw Blanket",
    image: "https://images.unsplash.com/photo-1580301762395-21ce84d00bc6?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 129.00,
    old_price: 169.00,
    date: "2025-12-12",
    available: true
  },
  {
    id: 43,
    name: "Macrame Wall Hanging",
    image: "https://images.unsplash.com/photo-1522758971460-1d21eed7dc1d?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 79.00,
    old_price: 109.00,
    date: "2025-12-13",
    available: true
  },
  {
    id: 44,
    name: "Round Decorative Mirror",
    image: "https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 179.00,
    old_price: 239.00,
    date: "2025-12-14",
    available: true
  },
  {
    id: 45,
    name: "Table Clock",
    image: "https://images.unsplash.com/photo-1563861826100-9cb868fdbe1c?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 69.00,
    old_price: 89.00,
    date: "2025-12-15",
    available: true
  },
  {
    id: 46,
    name: "Indoor Plant Stand",
    image: "https://images.unsplash.com/photo-1485955900006-10f4d324d411?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 119.00,
    old_price: 159.00,
    date: "2025-12-16",
    available: true
  },
  {
    id: 47,
    name: "Decorative Bookends",
    image: "https://images.unsplash.com/photo-1594620302200-9a762244a156?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 49.00,
    old_price: 69.00,
    date: "2025-12-17",
    available: true
  },
  {
    id: 48,
    name: "Woven Jute Rug",
    image: "https://images.unsplash.com/photo-1575414003591-ece8d0416c7a?auto=format&fit=crop&w=800&q=80",
    category: "decor",
    new_price: 199.00,
    old_price: 269.00,
    date: "2025-12-18",
    available: true
  }
];
